import { render, staticRenderFns } from "./EditReport.vue?vue&type=template&id=1a321735"
import script from "./EditReport.vue?vue&type=script&lang=js"
export * from "./EditReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports